class CustomDropdownMenu extends HTMLElement {
  connectedCallback() {
    this.addEventListener('pointerover', this.#onPointerOver);
    this.addEventListener('focusin', this.#onFocusIn);
    this.addEventListener('pointerleave', this.#clearAll);
    this.addEventListener('focusout', this.#onFocusOut);
    this.querySelectorAll('.custom-header-nav__dropdown-menu').forEach((menu) => {
      menu.addEventListener('scroll', this.#positionActiveFlyout, { passive: true });
    });
    window.addEventListener('resize', this.#positionActiveFlyout);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.#onPointerOver);
    this.removeEventListener('focusin', this.#onFocusIn);
    this.removeEventListener('pointerleave', this.#clearAll);
    this.removeEventListener('focusout', this.#onFocusOut);
    this.querySelectorAll('.custom-header-nav__dropdown-menu').forEach((menu) => {
      menu.removeEventListener('scroll', this.#positionActiveFlyout);
    });
    window.removeEventListener('resize', this.#positionActiveFlyout);
  }

  #onPointerOver = (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-custom-flyout-trigger]') : null;
    if (trigger instanceof HTMLElement) {
      this.#activateFlyout(trigger);
      return;
    }

    const link = event.target instanceof Element ? event.target.closest('.custom-header-nav__dropdown-link') : null;
    if (link instanceof HTMLElement) {
      this.#clearFlyouts(link.closest('.custom-header-nav__dropdown'));
    }
  };

  #onFocusIn = (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-custom-flyout-trigger]') : null;
    if (trigger instanceof HTMLElement) {
      this.#activateFlyout(trigger);
      return;
    }

    const link = event.target instanceof Element ? event.target.closest('.custom-header-nav__dropdown-link') : null;
    if (link instanceof HTMLElement) {
      this.#clearFlyouts(link.closest('.custom-header-nav__dropdown'));
    }
  };

  #onFocusOut = () => {
    requestAnimationFrame(() => {
      if (!this.contains(document.activeElement)) {
        this.#clearAll();
      }
    });
  };

  #activateFlyout(trigger) {
    const dropdown = trigger.closest('.custom-header-nav__dropdown');
    const flyoutId = trigger.dataset.customFlyoutTrigger;
    if (!(dropdown instanceof HTMLElement) || !flyoutId) return;

    const flyout = dropdown.querySelector(`#${flyoutId}`);
    if (!(flyout instanceof HTMLElement)) return;

    this.#clearFlyouts(dropdown);

    trigger.dataset.active = 'true';
    trigger.setAttribute('aria-expanded', 'true');
    flyout.dataset.active = 'true';

    this.#positionFlyout(trigger, flyout, dropdown);
  }

  #positionActiveFlyout = () => {
    this.querySelectorAll('[data-custom-flyout-trigger][data-active="true"]').forEach((trigger) => {
      const dropdown = trigger.closest('.custom-header-nav__dropdown');
      const flyoutId = trigger instanceof HTMLElement ? trigger.dataset.customFlyoutTrigger : null;
      const flyout = flyoutId && dropdown ? dropdown.querySelector(`#${flyoutId}`) : null;
      if (trigger instanceof HTMLElement && flyout instanceof HTMLElement && dropdown instanceof HTMLElement) {
        this.#positionFlyout(trigger, flyout, dropdown);
      }
    });
  };

  #positionFlyout(trigger, flyout, dropdown) {
    const menu = dropdown.querySelector('.custom-header-nav__dropdown-menu');
    if (!(menu instanceof HTMLElement)) return;

    const triggerRect = trigger.getBoundingClientRect();
    const dropdownRect = dropdown.getBoundingClientRect();
    const flyoutStyles = getComputedStyle(flyout);
    const flyoutPaddingTop = Number.parseFloat(flyoutStyles.paddingTop) || 0;
    const flyoutBorderTop = Number.parseFloat(flyoutStyles.borderTopWidth) || 0;
    const top = Math.max(0, triggerRect.top - dropdownRect.top - flyoutPaddingTop - flyoutBorderTop);
    const flyoutWidth = flyout.offsetWidth;
    const rightEdge = dropdownRect.left + menu.offsetWidth + flyoutWidth;

    if (rightEdge > window.innerWidth - 16) {
      flyout.style.setProperty('--custom-flyout-left', `${-flyoutWidth + 1}px`);
      flyout.dataset.align = 'left';
    } else {
      flyout.style.setProperty('--custom-flyout-left', `${menu.offsetWidth - 1}px`);
      flyout.dataset.align = 'right';
    }

    flyout.style.setProperty('--custom-flyout-top', `${top}px`);
  }

  #clearAll = () => {
    this.querySelectorAll('.custom-header-nav__dropdown').forEach((dropdown) => this.#clearFlyouts(dropdown));
  };

  #clearFlyouts(dropdown) {
    if (!(dropdown instanceof HTMLElement)) return;

    dropdown.querySelectorAll('[data-custom-flyout-trigger]').forEach((trigger) => {
      if (trigger instanceof HTMLElement) {
        delete trigger.dataset.active;
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    dropdown.querySelectorAll('.custom-header-nav__flyout-menu').forEach((flyout) => {
      if (flyout instanceof HTMLElement) {
        delete flyout.dataset.active;
        delete flyout.dataset.align;
      }
    });
  }
}

if (!customElements.get('custom-dropdown-menu')) {
  customElements.define('custom-dropdown-menu', CustomDropdownMenu);
}
